import { Above } from '@jetshop/ui/Breakpoints';
import BoolFilters from '@jetshop/ui/Filter/FilterTypes/BoolFilters';
import ListFilterFlyouts from '@jetshop/ui/Filter/FilterTypes/List/ListFilterFlyouts';
import RangeFilterFlyouts from '@jetshop/ui/Filter/FilterTypes/Range/RangeFilterFlyouts';
import theme from '@jetshop/ui/utils/theme';
import React, { Component } from 'react';
import { Query } from 'react-apollo';
import styled from 'react-emotion';
import MaxWidth from '../Layout/MaxWidth';
import CategoryHeader from './CategoryHeader';
import CategoryList from './CategoryList';
import CategoryParentQuery from './CategoryParentQuery.gql';
import CategoryToolbar from './CategoryToolbar';
import CustomListFilter, { CustomActiveList } from './Filters/CustomListFilter';
import FilterRegular from './Filters/FilterRegular';
import Products from './ProductLists/Products';
import UniversalProducts from './ProductLists/UniversalProducts';
import { excludeFilters } from './CategoryPage';

const CategoryContent = styled('div')`
    display: flex;
    flex-direction: column;
    width: 100%;

    ${theme('above.md')} {
        flex-direction: column;
    }

    margin-top: 2rem;
`;

const CategoryContainerWrapper = styled('div')`
    display: block;
    padding-right: 1em;
    padding-left: 2em;
    width: 76.5%;

    ${theme('below.md')} {
        flex-direction: column-reverse;
        padding: 0;
        width: 100%;
    }
`;

const NoProducts = styled('div')`
    border-top: 1px solid #9a9a9a;
    padding-top: 20px;
`;

const CustomLabelSpacing = styled('div')`
    display: flex;
    flex-grow: 1;

    > label {
        margin-right: 10px;
    }
`;

const FilterWrapper = styled('div')`
    display: flex;
    flex-wrap: wrap;

    svg {
        width: auto;
    }

    > div {
        width: 20%;
        padding-right: 10px;
        background: none;

        > button {
            height: 32px;
            text-transform: uppercase;

            + div button {
                text-transform: uppercase;
            }
        }
    }

    label {
        align-self: flex-start;
        margin-top: 5px;
        text-transform: uppercase;

        span {
            width: 18px;
            height: 18px;
        }
    }

    .handle {
        border-radius: 100% !important;
        height: 12px !important;
        width: 12px !important;
        margin-top: 2px !important;
        background: grey !important;
    }

    .slider {
        + button {
            height: 32px;
            font-size: 14px;
            text-transform: uppercase;
        }
    }
`;

const getFilters = (activeFilters, filters) => {
  if (!filters || !Array.isArray(filters)) return false;

  const multiListFilter = filters.find(
    (f) => f.__typename === 'MultiListFilter'
  );
  if (!multiListFilter) return false;

  const filterId = multiListFilter.id;
  const activeMultiList =
    activeFilters?.multiListFilters?.filter((f) => filterId.includes(f.id)) ||
    [];

  if (!activeFilters?.multiListFilters?.length) return false;

  const filter = filters.find((f) => f.__typename === 'MultiListFilter');

  if (
    filter &&
    activeMultiList[0] &&
    !filter.id.includes(activeMultiList[0].id)
  ) {
    return false;
  }

  return activeMultiList[0]?.values?.length === 3;
};

export default class CategoryContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showUniversal: false,
      showFilter: false,
      productView: 'list'
    };
  }

  // Not sure what to do with this.
  // The whole component causes a SSR / client missmatch...
  // Initializing it with 'grid' crashes rehydration between category/product.
  componentDidMount() {
    if (typeof window !== 'undefined') {
      if (typeof window.localStorage !== 'undefined') {
        const view = localStorage.getItem('view');
        if (view === 'grid') {
          this.setState({ productView: 'grid' });
        } else if (view === 'list') {
          this.setState({ productView: 'list' });
        } else {
          this.setState({ productView: 'grid' });
        }

        if (
          localStorage.getItem('universal') &&
          localStorage.getItem('universal') === 'true'
        ) {
          this.setState({ showUniversal: true });
        }
      }
    }
  }

  componentDidUpdate() {
    if (typeof window !== 'undefined') {
      if (typeof window.localStorage !== 'undefined') {
        if (
          localStorage.getItem('universal') &&
          localStorage.getItem('universal') === true
        ) {
          this.setState({ showUniversal: true });
        }
      }
    }
  }

  changeView = (view) => {
    this.setState({ productView: view });
  };

  showUniversal = () => {
    this.setState({ showUniversal: true });
    if (typeof window !== 'undefined') {
      if (typeof window.localStorage !== 'undefined') {
        localStorage.setItem('universal', true);
      }
    }
  };
  hideUniversal = () => {
    this.setState({ showUniversal: false });
    if (typeof window !== 'undefined') {
      if (typeof window.localStorage !== 'undefined') {
        localStorage.setItem('universal', false);
      }
    }
  };
  showFilter = () => {
    this.setState({ showFilter: !this.state.showFilter });
  };

  render() {
    const {
      category,
      loading,
      activeFilters,
      hasSelector,
      filters
    } = this.props;

    if (!category?.products) return null;

    const totalResults = category.products.totalResults || 0;
    const categoryFilters = excludeFilters(category.products.filters) || [];

    return (
      <CategoryContainerWrapper>
        <CategoryHeader category={category} />
        <CategoryContent>
          {(hasSelector && getFilters(activeFilters, categoryFilters)) ||
          (!hasSelector && totalResults > 0) ? (
            <React.Fragment>
              <React.Fragment>
                <Above breakpoint='md'>
                  {(matches) =>
                    matches ? (
                      <>
                        {hasSelector ? (
                          <CustomListFilter
                            showUniversal={this.showUniversal}
                            universalVisible={this.state.showUniversal}
                            filters={categoryFilters}
                          />
                        ) : (
                          <>
                            <FilterWrapper>
                              <ListFilterFlyouts
                                filters={categoryFilters}
                              />
                              <RangeFilterFlyouts
                                filters={categoryFilters}
                              />
                              <CustomLabelSpacing>
                                <BoolFilters
                                  filters={categoryFilters}
                                />
                              </CustomLabelSpacing>
                            </FilterWrapper>
                            <CustomActiveList
                              filters={categoryFilters}
                            />
                          </>
                        )}
                      </>
                    ) : (
                      <MaxWidth>
                        {filters && filters.length ? (
                          <FilterRegular filters={filters} />
                        ) : null}
                      </MaxWidth>
                    )
                  }
                </Above>
              </React.Fragment>
              <Above
                breakpoint='md'
                render={() => (
                  <React.Fragment>
                    {category.parentId !== null &&
                      !getFilters(activeFilters, categoryFilters) &&
                      category.hasSubcategories && (
                        <Query
                          query={CategoryParentQuery}
                          variables={{ catId: category.parentId }}
                        >
                          {({ loading, error, data }) => {
                            return (
                              <CategoryList
                                categoryName={category.name}
                                root={category.id}
                                parent={category.parentId}
                                grandParent={data?.category?.parentId}
                              />
                            );
                          }}
                        </Query>
                      )}
                  </React.Fragment>
                )}
              />

              <CategoryToolbar
                currentView={this.state.productView}
                changeView={this.changeView}
                hasSelector={hasSelector}
                filters={filters}
                activeFilters={activeFilters}
                showUniversal={this.showUniversal}
                hideUniversal={this.hideUniversal}
                universal={this.state.showUniversal}
                modelSelected={
                  activeFilters &&
                  activeFilters.multiListFilters &&
                  activeFilters.multiListFilters.length > 0 &&
                  activeFilters.multiListFilters[0].values.length === 3
                }
              />
              {this.state.showUniversal ? (
                <UniversalProducts
                  productView={this.state.productView}
                  changeView={this.changeView}
                  hasSelector={hasSelector}
                  modelSelected={
                    activeFilters &&
                    activeFilters.multiListFilters &&
                    activeFilters.multiListFilters.length > 0 &&
                    activeFilters.multiListFilters[0].values.length === 3
                  }
                  catId={category.id}
                  mainCat={category}
                />
              ) : category.products.totalResults > 0 ? (
                <Products
                  productView={this.state.productView}
                  filters={filters}
                  hasSelector={hasSelector}
                  category={category}
                  activeFilters={activeFilters}
                  loading={loading}
                />
              ) : (
                <NoProducts>
                  Det finns tyvärr ingen produkt i denna kategori som är listad
                  till din modell. Slå av filter för att även se
                  universalprodukter och produkter som passar andra modeller
                </NoProducts>
              )}
            </React.Fragment>
          ) : category.hasSubcategories ? (
            <Query
              query={CategoryParentQuery}
              variables={{ catId: category.id }}
            >
              {({ loading, error, data }) => {
                return (
                  <CategoryList
                    categoryName={category.name}
                    root={category.id}
                    parent={category.parentId}
                    grandParent={data?.category?.parentId}
                  />
                );
              }}
            </Query>
          ) : category.products.totalResults > 0 ? (
            <>
              <CategoryToolbar
                currentView={this.state.productView}
                changeView={this.changeView}
                hasSelector={hasSelector}
                filters={filters}
                activeFilters={activeFilters}
                showUniversal={this.showUniversal}
                hideUniversal={this.hideUniversal}
                universal={this.state.showUniversal}
                modelSelected={
                  activeFilters &&
                  activeFilters.multiListFilters &&
                  activeFilters.multiListFilters.length > 0 &&
                  activeFilters.multiListFilters[0].values.length === 3
                }
              />
              <Products
                productView={this.state.productView}
                filters={filters}
                hasSelector={hasSelector}
                category={category}
                activeFilters={activeFilters}
                loading={loading}
              />
            </>
          ) : null}
        </CategoryContent>
      </CategoryContainerWrapper>
    );
  }
}
